import React from 'react';
import styles from './NoResultsIcon.module.scss';

export const NoResultsIcon: React.FC = () => (
	<svg
		aria-hidden='true'
		className={styles.noResultsIcon}
		viewBox='0 0 48 48'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5.42,26.07A11.32,11.32,0,0,1,21.06,10.43l1.18-1.18a13,13,0,0,0-18,18Z'
			fill='#170b01'
		/>
		<path
			d='M24.5,13.86A11.32,11.32,0,0,1,8.85,29.51L7.68,30.69a13,13,0,0,0,18-18Z'
			fill='#170b01'
		/>
		<path
			d='M2.81,32.93a.81.81,0,0,1-.57-1.38l24.3-24.3A.81.81,0,1,1,27.7,8.37l0,0L3.38,32.69A.82.82,0,0,1,2.81,32.93Z'
			fill='#170b01'
		/>
		<path
			d='M35.31,36.88,25.09,26.67a12.18,12.18,0,0,1-3.43,3.43L31.87,40.32a2.43,2.43,0,0,0,3.44-3.44Z'
			fill='#170b01'
		/>
	</svg>
);
